import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async () => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) throw redirect({ to: "/auth" });

    // Enforce email verification - users must verify via OTP before accessing
    try {
      const { data: profile } = await supabase
        .from("profiles")
        .select("email_verified")
        .eq("id", data.user.id)
        .maybeSingle();

      if (profile && profile.email_verified === false) {
        throw redirect({ to: "/auth" });
      }
    } catch (e) {
      if (e instanceof Response && e.status === 302) throw e;
    }

    return { user: data.user };
  },
  component: () => <Outlet />,
});
